import React from 'react';
import { EntityDecisionsParams } from '../../entity/entity.types';
import {
  ModalScrollableContent,
  ModalScrollableContainer,
  ModalScrollableBody,
} from '../../components/modal';
import { EntityDecisionList } from './EntityDecisionList';
import { EntityDecisionListFetcher } from './EntityDecisionListFetcher';
import { EntityDecisionListModalHeader } from './EntityDecisionListModalHeader';
import { EntityDecisionLoader } from './EntityDecisionLoader';

type Props = {
  entityName: string;
  wording: string;
  params: EntityDecisionsParams;
  source: string;
  onRequestClose: () => void;
  isOpen: boolean;
};

export class EntityDecisionListModal extends React.Component<Props> {
  static defaultProps = {
    onRequestClose: () => {},
    isOpen: false,
  };

  render() {
    const {
      isOpen,
      onRequestClose,
      params,
      source,
      entityName,
      wording,
    } = this.props;
    return (
      <ModalScrollableContainer isOpen={isOpen} onRequestClose={onRequestClose}>
        <EntityDecisionListFetcher params={params}>
          {(decisions) => (
            <>
              <EntityDecisionListModalHeader
                title={entityName}
                subtitle={`${wording} dans ${decisions.length} décision${
                  decisions.length > 1 ? 's' : ''
                }`}
                onClose={onRequestClose}
              />
              <ModalScrollableContent>
                <ModalScrollableBody>
                  {decisions.length ? (
                    <EntityDecisionList decisions={decisions} source={source} />
                  ) : (
                    <EntityDecisionLoader />
                  )}
                </ModalScrollableBody>
              </ModalScrollableContent>
            </>
          )}
        </EntityDecisionListFetcher>
      </ModalScrollableContainer>
    );
  }
}
